import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
// import * as actions from '../../actions'
// import * as actionCreators from '../../actions';
import { renderTextField, renderCheckbox, renderSelectField, renderDatePicker } from '../auth/form_helpers'

import '../../style/style.css';

import RaisedButton from 'material-ui/RaisedButton'
// import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
// import Popover from 'material-ui/Popover';
// import Checkbox from 'material-ui/Checkbox';
// import Divider from 'material-ui/Divider';
// import TextField from 'material-ui/TextField'
// import DatePicker from 'material-ui/DatePicker';
import Paper from 'material-ui/Paper';
// import TextField from 'material-ui/TextField';
import ContentClear from 'material-ui/svg-icons/content/clear';
import IconButton from 'material-ui/IconButton';

// import * as actionCreator from '../../actions'

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  thin: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
    background: '#E1F5FE',
  },
  halfthin: {
    paddingBottom: 0,
    marginBottom: 0,
    background: '#E1F5FE',
  },
  tobottom: {
    bottom: 0,
    top: "auto"
  }
};

class PersonListAdvancedFilter extends Component {

  constructor(props) {
    super(props)

    this.state = {
      selectedPsychotherapist: false
    }
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  /*
  componentDidUpdate() {
    if (typeof this.props.filtertracker !== 'undefined') {
      if (typeof this.props.filtertracker.values !== 'undefined') {
        if (typeof this.props.filtertracker.values.psychoterapist !== 'undefined') {
          if (typeof this.props.filtertracker.values.psychoterapist.isPsychotherapista !== 'undefined') {
            if (this.props.filtertracker.values.psychoterapist.isPsychotherapista !== '---') {
              this.setState({selectedPsychotherapist: true})
            }
          }
        }
      }
    }
    if (typeof this.props.filtertracker !== 'undefined') {
      if (typeof this.props.filtertracker.values !== 'undefined') {
        if (typeof this.props.filtertracker.values.psychoterapist !== 'undefined') {
          if (typeof this.props.filtertracker.values.psychoterapist.isPsychotherapista !== 'undefined') {
            if (this.props.filtertracker.values.psychoterapist.isPsychotherapista === '---') {
              this.setState({selectedPsychotherapist: false})
            }
          }
        }
      }
    }
  }
  */

  renderCategories() {
    if(typeof this.props.personcategories !== 'undefined') {
      this.props.personcategories[0].map((option, index) => {
        switch (option) {
          case 'all': 
            return <MenuItem key={index} value={option} primaryText="összes" />
          case 'is-member': 
            return <MenuItem key={index} value={option} primaryText="tag" />
          case 'was-in-training': 
            return <MenuItem key={index} value={option} primaryText="kurzuson részt vett" />
          case 'self-knowledge-only': 
            return <MenuItem key={index} value={option} primaryText="csak önismereti" />
          default: 
            return <MenuItem key={index} value={option} primaryText={option} />
        }
      })
    }
  }
/*
  renderBirthday() {
    if (typeof this.props.filteroptions.personal !== 'undefined') {
      if (typeof this.props.filteroptions.personal.birthday !== 'undefined') {
        return <div>
          <Field
            className={
              typeof this.props.filtertracker !== 'undefined' ?
                typeof this.props.filtertracker.values !== 'undefined' ?
                  typeof this.props.filtertracker.values.personal !== 'undefined' ?
                    typeof this.props.filtertracker.values.personal.birthday !== 'undefined' ?
                      this.props.filtertracker.values.personal.birthday === null ? 'personalBirthday dateInput deleted'
                      : 'personalBirthday dateInput'
                    : 'personalBirthday dateInput'
                  : 'personalBirthday dateInput'
                : 'personalBirthday dateInput'
              : 'personalBirthday dateInput'
            }
            component={renderDatePicker}
            label="születésnap"
            floatingLabelText="született"
            hintText="született"
            type="text"
            style={{width: 120}}
            defaultDate={new Date(this.props.filteroptions.personal.birthday)}
            name="personal.birthday"
            ref='refpersonalBirthday dateInput'
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="personal.birthday"
            type="text"
          />
        {
          typeof this.props.filtertracker !== 'undefined' ?
            typeof this.props.filtertracker.values !== 'undefined' ?
              typeof this.props.filtertracker.values.personal !== 'undefined' ?
                typeof this.props.filtertracker.values.personal.birthday !== 'undefined' ?
                  this.props.filtertracker.values.personal.birthday !== null ? (<div className="">
                      <IconButton onClick={this.delete("personal.birthday")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
        </div>
      } else {
        return <div>
          <Field
            className={
              typeof this.props.filtertracker !== 'undefined' ?
                typeof this.props.filtertracker.values !== 'undefined' ?
                  typeof this.props.filtertracker.values.personal !== 'undefined' ?
                    typeof this.props.filtertracker.values.personal.birthday !== 'undefined' ?
                      this.props.filtertracker.values.personal.birthday === null ? 'personalBirthday dateInput deleted'
                      : 'personalBirthday dateInput'
                    : 'personalBirthday dateInput'
                  : 'personalBirthday dateInput'
                : 'personalBirthday dateInput'
              : 'personalBirthday dateInput'
            }
            component={renderDatePicker}
            label="születésnap"
            floatingLabelText="született"
            hintText="született"
            type="text"
            style={{width: 120}}
            name="personal.birthday"
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="personal.birthday"
            type="text"
          />
          {
            typeof this.props.filtertracker !== 'undefined' ?
              typeof this.props.filtertracker.values !== 'undefined' ?
                typeof this.props.filtertracker.values.personal !== 'undefined' ?
                  typeof this.props.filtertracker.values.personal.birthday !== 'undefined' ?
                    this.props.filtertracker.values.personal.birthday !== null ? (<div className="">
                        <IconButton onClick={this.delete("personal.birthday")} className="deleteIcon">
                          <ContentClear />
                        </IconButton>
                      </div>)
                    : void(0)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          }
        </div>
      }
    } else {
      return <div>
        <Field
          className={
            typeof this.props.filtertracker !== 'undefined' ?
              typeof this.props.filtertracker.values !== 'undefined' ?
                typeof this.props.filtertracker.values.personal !== 'undefined' ?
                  typeof this.props.filtertracker.values.personal.birthday !== 'undefined' ?
                    this.props.filtertracker.values.personal.birthday === null ? 'personalBirthday dateInput deleted'
                    : 'personalBirthday dateInput'
                  : 'personalBirthday dateInput'
                : 'personalBirthday dateInput'
              : 'personalBirthday dateInput'
            : 'personalBirthday dateInput'
          }
          component={renderDatePicker}
          label="születésnap"
          floatingLabelText="született"
          hintText="született"
          type="text"
          style={{width: 120}}
          name="personal.birthday"
        />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="personal.birthday"
            type="text"
          />
        {
          typeof this.props.filtertracker !== 'undefined' ?
            typeof this.props.filtertracker.values !== 'undefined' ?
              typeof this.props.filtertracker.values.personal !== 'undefined' ?
                typeof this.props.filtertracker.values.personal.birthday !== 'undefined' ?
                  this.props.filtertracker.values.personal.birthday !== null ? (<div className="">
                      <IconButton onClick={this.delete("personal.birthday")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    }
  }
*/
  delete (text) {
    return () => {
        this.props.change(text, null)
    }
  }

  render() {
    if(typeof this.props.personcategories !== 'undefined' && typeof this.props.filtertracker !== 'undefined' && typeof this.props.filtertracker.values !== 'undefined' && typeof this.props.qualification !== 'undefined' && typeof this.props.qualificationtypes !== 'undefined' && typeof this.props.membership !== 'undefined') {
      const {handleSubmit} = this.props
      return (
        <div>
          {/*this.props.personal.name*/}
          {this.renderAlert()}
          <form onSubmit={handleSubmit} className='formFormat'>
            <div className="full">
              <h3 style={{paddingTop: 10}}>Részletes keresés</h3>
            </div>
            <div className='flexContainer' style={{paddingTop: 60}}>
              <Paper zDepth={1}>
                <label>Személyes adatok:</label>
                <br />
                <Field
                  component={renderTextField}
                  floatingLabelText="név"
                  name="personal.name"
                  style={{
                    display: "inline-block",
                    maxWidth: 320
                  }}
                  type="text"/>
                <br />
                <Field
                  component={renderTextField}
                  floatingLabelText="született"
                  name="personal.birthday"
                  type="text"
                />
                <br />
                <Field
                  component={renderSelectField}
                  floatingLabelText="meghalt"
                  name="personal.isDead"
                  // defaultValue={this.props.filteroptions.personal.isDead}
                  menuStyle={{top: 'auto', bottom: 0}} // ez valamiért nem megy
                  //maxHeight={60} // ez a workaround a fentire
                >
                  <MenuItem key={1} value={"---"} primaryText="nincs beállítva" />
                  <MenuItem key={2} value={"true"} primaryText="igen" />
                  <MenuItem key={3} value={"false"} primaryText="nem" />
                </Field>
                <br />
              </Paper>
              <Paper zDepth={1}>
                <label>Cím</label>
                <br />
                <Field
                  component={renderTextField}
                  floatingLabelText="irányítószám"
                  name="personal.address.zip"
                  type="text"/>
                <Field
                  component={renderTextField}
                  floatingLabelText="ország"
                  name="personal.address.country"
                  type="text"/>
                <Field
                  component={renderTextField}
                  floatingLabelText="város"
                  name="personal.address.city"
                  type="text"/>
                <Field
                  component={renderTextField}
                  floatingLabelText="lakcím"
                  name="personal.address.address"
                  type="text"/>
              </Paper>
              <Paper zDepth={1}>
                <label>Elérhetőség:</label>
                <Field
                  component={renderTextField}
                  floatingLabelText="email"
                  name="personal.email"
                  type="text"/>
                <Field
                  component={renderTextField}
                  floatingLabelText="telefonszám"
                  name="personal.phone"
                  type="text"/>
                <Field
                  component={renderSelectField}
                  floatingLabelText="publikus elérhetőség"
                  name="personal.isPublicContact"
                  // defaultValue={this.props.filteroptions.personal.isDead}
                  menuStyle={{top: 'auto', bottom: 0}} // ez valamiért nem megy
                  //maxHeight={60} // ez a workaround a fentire
                >
                  <MenuItem key={1} value={"---"} primaryText="nincs beállítva" />
                  <MenuItem key={2} value={"true"} primaryText="igen" />
                  <MenuItem key={3} value={"false"} primaryText="nem" />
                </Field>
                <br />
              </Paper>
              <Paper zDepth={1}>
                <label>Rendszeradatok:</label>
                <br />
                <Field
                  component={renderTextField}
                  floatingLabelText="TB szám"
                  name="system.tbNumber"
                  style={{width: 160}}
                  type="text"/>
                <Field
                  component={renderTextField}
                  floatingLabelText="index szám"
                  name="system.indexNumber"
                  style={{width: 160}}
                  type="text"/>
                <br />
                <Field
                  component={renderSelectField}
                  floatingLabelText="hírlevelet kér"
                  name="system.isNewsletter"
                >
                  <MenuItem key={1} value={"---"} primaryText="nincs beállítva" />
                  <MenuItem key={2} value={"true"} primaryText="igen" />
                  <MenuItem key={3} value={"false"} primaryText="nem" />
                </Field>
              </Paper>
              <Paper zDepth={1}>
                <label>Pszichoterapeuta-állapot:</label>
                <br />
                <Field
                  component={renderSelectField} // true, if other 3 true
                  floatingLabelText="pszichoterapeuta"
                  name="psychoterapist.isPsychotherapist"
                  className="psychotherapist"
                >
                  <MenuItem key={1} value={"---"} primaryText="nincs beállítva" />
                  <MenuItem key={2} value={"true"} primaryText="igen" />
                </Field>
                <br />
                {}
                <Field
                  component={renderSelectField} 
                  className={
                    typeof this.props.filtertracker !== 'undefined' ?
                      typeof this.props.filtertracker.values !== 'undefined' ?
                        typeof this.props.filtertracker.values.psychoterapist !== 'undefined' ?
                          typeof this.props.filtertracker.values.psychoterapist.isPsychotherapist !== 'undefined' ?
                            this.props.filtertracker.values.psychoterapist.isPsychotherapist !== '---' ?
                              this.props.filtertracker.values.psychoterapist.isPsychotherapist === '' ?
                                'forpsychotherapist'
                              :'hidden forpsychotherapist'
                            : 'forpsychotherapist'
                          : 'forpsychotherapist'
                        : 'forpsychotherapist'
                      : 'forpsychotherapist'
                    : 'forpsychotherapist'
                  }
                  floatingLabelText="betegcsoport"
                  name="psychoterapist.isPatientgroup"
                >
                  <MenuItem key={1} value={"---"} primaryText="nincs beállítva" />
                  <MenuItem key={2} value={"true"} primaryText="igen" />
                  <MenuItem key={3} value={"false"} primaryText="nem" />
                </Field>
                <br />
                <Field
                  component={renderSelectField}
                  className={
                    typeof this.props.filtertracker !== 'undefined' ?
                      typeof this.props.filtertracker.values !== 'undefined' ?
                        typeof this.props.filtertracker.values.psychoterapist !== 'undefined' ?
                          typeof this.props.filtertracker.values.psychoterapist.isPsychotherapist !== 'undefined' ?
                            this.props.filtertracker.values.psychoterapist.isPsychotherapist !== '---' ?
                              this.props.filtertracker.values.psychoterapist.isPsychotherapist === '' ?
                                'forpsychotherapist'
                              :'hidden forpsychotherapist'
                            : 'forpsychotherapist'
                          : 'forpsychotherapist'
                        : 'forpsychotherapist'
                      : 'forpsychotherapist'
                    : 'forpsychotherapist'
                  }
                  floatingLabelText="elmélet"
                  name="psychoterapist.isTheory"
                >
                  <MenuItem key={1} value={"---"} primaryText="nincs beállítva" />
                  <MenuItem key={2} value={"true"} primaryText="igen" />
                  <MenuItem key={3} value={"false"} primaryText="nem" />
                </Field>
                <br />
                <Field
                  component={renderSelectField}
                  className={
                    typeof this.props.filtertracker !== 'undefined' ?
                      typeof this.props.filtertracker.values !== 'undefined' ?
                        typeof this.props.filtertracker.values.psychoterapist !== 'undefined' ?
                          typeof this.props.filtertracker.values.psychoterapist.isPsychotherapist !== 'undefined' ?
                            this.props.filtertracker.values.psychoterapist.isPsychotherapist !== '---' ?
                              this.props.filtertracker.values.psychoterapist.isPsychotherapist === '' ?
                                'forpsychotherapist'
                              :'hidden forpsychotherapist'
                            : 'forpsychotherapist'
                          : 'forpsychotherapist'
                        : 'forpsychotherapist'
                      : 'forpsychotherapist'
                    : 'forpsychotherapist'
                  }
                  floatingLabelText="szakvizsga"
                  name="psychoterapist.isExam"
                >
                  <MenuItem key={1} value={"---"} primaryText="nincs beállítva" />
                  <MenuItem key={2} value={"true"} primaryText="igen" />
                  <MenuItem key={3} value={"false"} primaryText="nem" />
                </Field>
              </Paper>
              <Paper zDepth={1}>
                <label>Egyéb:</label>
                <br />
                <Field
                  component={renderTextField}
                  floatingLabelText="diploma"
                  name="diplomas"
                  style={{width: 320}}
                  type="text"/>
                <br />
                <Field
                  component={renderSelectField}
                  floatingLabelText="tagi státusz"
                  name="membershipType"
                  style={{width: 320}}
                >
                  <MenuItem key={0} value="---" primaryText="nincs beállítva" />
                  {
                    this.props.membership.map((option, index) => {
                      return <MenuItem key={index} value={option} primaryText={option} />
                    })
                  }
                </Field>
                <br />
                <Field
                  component={renderSelectField}
                  floatingLabelText="Minősítés:"
                  name="qualification"
                  style={{width: 320}}
                  type="text"
                >
                  <MenuItem key={0} value="---" primaryText="nincs beállítva" />
                  {
                    this.props.qualification.map((option, index) => {
                      return option.validTypes.map((item, num) => {
                        return <MenuItem key={(10*index)+num} value={option.value+'-'+item} primaryText={option.value+'-'+item} />
                      })
                    })
                  }
                </Field>
              </Paper>
              
              <div style={{display: 'none'}}>
                <Paper  zDepth={1} className='flexEnd p15'>
                  <RaisedButton className="AdvancedFilterSubmitButton" type="submit" label="szűrés" primary={true} labelColor={'#FFFFFF'}/>
                </Paper>
              </div>
            </div>
          </form>
        </div>
      )
    } else {
      return (
        <div></div>
      )
    }
  }

}

const validate = values => {
  const errors = {personal: {address: {}}, system: {}, psychoterapist: {}}

  if (
    (typeof values.personal.name === 'undefined' ||
    (typeof values.personal.name !== 'undefined' &&
    values.personal.name.trim() === '')) &&

    (typeof values.personal.birthday === 'undefined' ||
    (typeof values.personal.birthday !== 'undefined' &&
    values.personal.birthday.trim() === '')) &&

    (typeof values.personal.isDead === 'undefined' ||
    (typeof values.personal.isDead !== 'undefined' &&
    values.personal.isDead.trim() === '---') ||
    values.personal.isDead.trim() === '') &&

    (typeof values.personal.address.zip === 'undefined' ||
    (typeof values.personal.address.zip !== 'undefined' &&
    values.personal.address.zip.trim() === '')) &&

    (typeof values.personal.address.country === 'undefined' ||
    (typeof values.personal.address.country !== 'undefined' &&
    values.personal.address.country.trim() === '')) &&

    (typeof values.personal.address.city === 'undefined' ||
    (typeof values.personal.address.city !== 'undefined' &&
    values.personal.address.city.trim() === '')) &&

    (typeof values.personal.address.address === 'undefined' ||
    (typeof values.personal.address.address !== 'undefined' &&
    values.personal.address.address.trim() === '')) &&

    (typeof values.personal.email === 'undefined' ||
    (typeof values.personal.email !== 'undefined' &&
    values.personal.email.trim() === '')) &&

    (typeof values.personal.phone === 'undefined' ||
    (typeof values.personal.phone !== 'undefined' &&
    values.personal.phone.trim() === '')) &&

    (typeof values.personal.isPublicContact === 'undefined' ||
    (typeof values.personal.isPublicContact !== 'undefined' &&
    values.personal.isPublicContact.trim() === '---' ) || 
    values.personal.isPublicContact.trim() === '') &&

    (typeof values.system.tbNumber === 'undefined' ||
    (typeof values.system.tbNumber !== 'undefined' &&
    values.system.tbNumber.trim() === '')) &&

    (typeof values.system.indexNumber === 'undefined' ||
    (typeof values.system.indexNumber !== 'undefined' &&
    values.system.indexNumber.trim() === '')) &&

    (typeof values.system.isNewsletter === 'undefined' ||
    (typeof values.system.isNewsletter !== 'undefined' &&
    values.system.isNewsletter.trim() === '---') ||
    values.system.isNewsletter.trim() === '') &&

    (typeof values.psychoterapist.isPatientgroup === 'undefined' ||
    (typeof values.psychoterapist.isPatientgroup !== 'undefined' &&
    values.psychoterapist.isPatientgroup.trim() === '---') ||
    values.psychoterapist.isPatientgroup.trim() === '') &&

    (typeof values.psychoterapist.isTheory === 'undefined' ||
    (typeof values.psychoterapist.isTheory !== 'undefined' &&
    values.psychoterapist.isTheory.trim() === '---') ||
    values.psychoterapist.isTheory.trim() === '') &&

    (typeof values.psychoterapist.isExam === 'undefined' ||
    (typeof values.psychoterapist.isExam !== 'undefined' &&
    values.psychoterapist.isExam.trim() === '---') ||
    values.psychoterapist.isExam.trim() === '') &&

    (typeof values.psychoterapist.isPsychotherapist === 'undefined' ||
    (typeof values.psychoterapist.isPsychotherapist !== 'undefined' &&
    values.psychoterapist.isPsychotherapist.trim() === '---') ||
    values.psychoterapist.isPsychotherapist.trim() === '') &&

    (typeof values.diplomas === 'undefined' ||
    (typeof values.diplomas !== 'undefined' &&
    values.diplomas.trim() === '')) &&

    (typeof values.membershipType === 'undefined' ||
    (typeof values.membershipType !== 'undefined' &&
    values.membershipType.trim() === '---') ||
    values.membershipType.trim() === '') &&

    (typeof values.qualification === 'undefined' ||
    (typeof values.qualification !== 'undefined' &&
    values.qualification.trim() === '---') ||
    values.qualification.trim() === '')

  ) {
    errors.qualification = "Legalább egy keresőmező kitöltése kötelezői!"
  }
  return errors
}

PersonListAdvancedFilter = reduxForm({
  form: 'personListAdvancedFilter',
  validate
})(PersonListAdvancedFilter)

// You have to connect() to any reducers that you wish to connect to yourself
PersonListAdvancedFilter = connect(
  state => ({
    initialValues: state.person.filteroptions, // pull initial values from reducer
    enableReinitialize : true
  })
)(PersonListAdvancedFilter)

export default PersonListAdvancedFilter


// WEBPACK FOOTER //
// ./src/components/persons/personListAdvancedFilter.js